import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AssetConfigurationPage from './components/asset-configuration-page';
import Player from './components/player-page';

export default class App extends React.Component<{}, {}> {
    public render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={AssetConfigurationPage} />
                    <Route exact path="/player" component={Player} />
                </Switch>
            </BrowserRouter>
        );
    }
}
